import axios from "axios"
import router from "@/router"
import store from "@/store/index"
import { Message } from "element-ui"
import _ from "lodash"
import { getToken } from "./tokenManager"

axios.defaults.baseURL = "/api"
axios.defaults.validateStatus = status => {
  return status > 0
}

// 模板中心发送请求白名单
const specialUrls = [
  "/users/installApp" // 模板中心安装模板时,允许调用真实接口,接口内已经做权限验证
]

// 请求拦截器
axios.interceptors.request.use(
  config => {
    if (store.getters.isTemplateMode) {
      if (!config.url.startsWith("/public") && !specialUrls.includes(config.url)) {
        console.log("非法请求", config.url)
        return Promise.reject("非法请求")
      }
      return config
    }
    if (router.currentRoute.meta.public) {
      return config
    }
    config.headers.Authorization =
      "Bearer " +
      getToken(
        router.currentRoute.name?.includes("board-share")
          ? router.currentRoute.params.boardId || router.currentRoute.query.boardId
          : null
      )

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response.config.url, "请求返回值", response)
    // 未登录
    if ([401, 403, 456].includes(response.status)) {
      if (router.currentRoute.name.includes("board-share")) {
        Message.warning("登录信息失效")
        store.dispatch("user/logout")
        location.href = `${router.currentRoute.fullPath}`
        return
      } else if (router.currentRoute.name !== "login") {
        Message.warning("登录信息失效")
        store.dispatch("user/logout")
        location.href = `/login?redirect=${router.currentRoute.fullPath}`
        // router.push(`/login?redirect=${router.currentRoute.fullPath}`)
        return
      }
    }

    // 若响应头里的token更改，则重新设置 token, userInfo, axios headers, userPermission
    if (response.headers.authorization) {
      return new Promise((resolve, reject) => {
        store
          .dispatch("user/setToken", {
            token: response.headers.authorization,
            share: router.currentRoute.name?.includes("board-share")
              ? router.currentRoute.params.boardId || router.currentRoute.query.boardId
              : null
          })
          .then(() => {
            resolve(response)
          })
      })
    }

    return response
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * 报错计数(因后端升级),辅助防抖
 * @type {number}
 */
let errorCount = 0
Promise.prototype.commonDeal = function() {
  return this.then(rsp => {
    let code = _.get(rsp, "data.code")
    let msg = _.get(rsp, "data.msg")
    let data = _.get(rsp, "data.data")
    // 成功响应，直接返回数据
    if (code === 0) {
      errorCount = 0
      return data
    }
    // 失败响应，返回详细信息
    if (code === 10000 && !router.currentRoute.meta.public) {
      // 10000表示后端系统http响应码大于500,认为是后端服务不可用.
      // 此时跳转到升级页面(升级页面因为有标题栏,不应该公开访问.这种情况下,就只提示错误信息)
      if (++errorCount > 3) {
        // 但是由于后端接口负载均衡偶尔会出现抖动,做一下特殊处理(连续三个接口都返回10000)
        router.goto({ name: "upgrade" })
      }
    }
    Message.error(msg || "请求出错，请重试")
    return Promise.reject(rsp?.data)
  })
}

export default axios
